import { BodyText, Heading } from '@farol-ds/react'
import { Image } from '@jusbrasil-web/shared-next-image'

import styles from './lock-wall.module.scss'
import lockWallImage from './lock-wall.svg'

export interface LockWallProps {
  title: string
  subtitle?: string
  children?: React.ReactNode
}

export const LockWall = (props: LockWallProps) => {
  const { title, subtitle, children } = props

  return (
    <div className={styles.lockWall}>
      <div className={styles.lockWallInner}>
        <Image
          className={styles.lockWallImage}
          src={lockWallImage}
          alt="Figura representando 3 páginas da internet, com a principal contendo o logo do Jusbrasil"
          loading="lazy"
        />

        <Heading>{title}</Heading>

        {subtitle && <BodyText>{subtitle}</BodyText>}

        {children}
      </div>
    </div>
  )
}
